module.exports = __webpack_public_path__ + "img/5.358a6454.png";